import { useAppSelector } from "@redux/hooks";
import {
    isLocationReservationsEnabledSelector,
    isReservationsEnabledSelector,
} from "@redux/features/auth/authSlice";

/**
 * Hook to check if the reservations feature is enabled for the current company.
 *
 * @returns {boolean} True if reservations are enabled, false otherwise.
 */
export function useIsReservationsEnabled(): boolean {
    return useAppSelector(isReservationsEnabledSelector);
}

/**
 * Hook to check if per-location reservations (made at a specific location / section) are enabled for the current company.
 *
 * @returns {boolean} True if both reservations and per-location reservations are enabled.
 */
export function useIsLocationReservationsEnabled(): boolean {
    return useAppSelector(isLocationReservationsEnabledSelector);
}
